// extracted by mini-css-extract-plugin
export default {"ProductPageApp":"l7SIaB","productPageApp":"l7SIaB","errorToast":"q8XtxH"};